module.exports = "img/photo27.1ef511.jpg";